import * as Styled from './styled';

type ErrorMessageProps = {
  title: string;
  code?: React.ReactNode;
  children: React.ReactNode;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({ title, code, children }) => {
  return (
    <Styled.ErrorMessage>
      {title && <Styled.Title>{title}</Styled.Title>}
      {children}
      {code && <Styled.Code>{code}</Styled.Code>}
    </Styled.ErrorMessage>
  );
};

export default ErrorMessage;
